module.exports = __webpack_public_path__ + "static/hajek-b42031b85e1282c8179881ff0fef2c2e.jpg";